import { FC } from 'react';
import { getLoanTypeNameFromLoanTypeId } from '../../helpers';

type Props = {
  id: number;
};
const LoanTypeBadge: FC<Props> = ({ id }) => {
  const loanType = getLoanTypeNameFromLoanTypeId(id);

  return <span className={`badge badge-light-${loanType.split(' ').join('_')} fs-7 fw-bold`}>{loanType}</span>;
};

export default LoanTypeBadge;
